module.exports = __webpack_public_path__ + "static/media/logo_login.eb20f70b.svg";